let content_blocks = require('../contents');

export function init(microsite_id, content_id){

    $('#edit_slider_images_modal .btn.delete').on('click', function(){

        let modal = $(this).closest('.modal');
        let block_id = modal.find('[name="block_id"]').val();
        $('#'+block_id).remove();

        content_blocks.show_start_block();
        content_blocks.show_block_order();

        modal.modal('hide');
        modal.find('form')[0].reset();

    });

    $('#edit_slider_images_modal').on('show.bs.modal', function (event) {
        let button = $(event.relatedTarget);
        let block = $(button).closest('.block');
        let modal = $(this);
        modal.find('[name="block_id"]').val(block.attr('id'));
        modal.find('[name="classes"]').val(block.attr('data-class'));
        modal.find('[name="xs_images"]').val(block.attr('data-xs-images'));
        modal.find('[name="md_images"]').val(block.attr('data-md-images'));
        modal.find('[name="xl_images"]').val(block.attr('data-xl-images'));
        modal.find('[name="full_width"]').prop('checked', block.attr('data-full-width') == 'true' ? true : false);
        modal.find('[name="autoplay"]').prop('checked', block.attr('data-autoplay') == 'true' ? true : false);
        modal.find('[name="interval"]').val(block.attr('data-interval'));

        let select_visible = modal.find('[name="visible"]');
        if (block.attr('data-visible') != null || block.attr('data-visible') != 'undefined') {
            select_visible.find('option[value="'+ block.attr('data-visible')).prop('selected', true);
        } else {
            select_visible.find('option[value="visible"]').prop('selected', true);
        }
        
        select_visible.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });
    });

    $('#edit_slider_images').on('submit', function (e) {
        e.preventDefault();
        let block = $('#'+ $(this).find('[name="block_id"]').val());
        block.attr('data-full-width', $(this).find('[name="full_width"]').prop('checked'));
        block.attr('data-autoplay', $(this).find('[name="autoplay"]').prop('checked'));
        block.attr('data-interval', $(this).find('[name="interval"]').val());
        block.attr('data-class', $(this).find('[name="classes"]').val());
        block.attr('data-visible', $(this).find('[name="visible"]').val());
        block.attr('data-xs-images', $(this).find('[name="xs_images"]').val());
        block.attr('data-md-images', $(this).find('[name="md_images"]').val());
        block.attr('data-xl-images', $(this).find('[name="xl_images"]').val());
        
        content_blocks.change_visible_button_blocks(block);

        let modal = $(this).closest('.modal');
        modal.modal('hide');

        $(this)[0].reset();
    });

    $('#add_slide_images_modal').on('show.bs.modal', function (event) {
        let button = $(event.relatedTarget);
        let block = $(button).closest('.block');
        let prev_slide = $(button).closest('.slide_images');
        let modal = $(this);
        modal.find('[name="block_id"]').val(block.attr('id'));
        modal.find('[name="prev_slide_images_id"]').val(prev_slide.attr('id'));

        let select_visible = modal.find('[name="visible"]');

        select_visible.find('option[value="visible"]').prop('selected', true);

        select_visible.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });
    });

    $('#edit_slide_images_modal .btn.delete').on('click', function(){
        
        let modal = $(this).closest('.modal');
        let block_id = modal.find('[name="slide_images_id"]').val();
        let row_id = $('#'+block_id).closest('.block').attr('id');
        $('#'+block_id).remove();
        
        // content_blocks.show_start_block();
        // content_blocks.show_block_order();

        show_block_order(row_id);
        init_slider_images_block(row_id);

        modal.modal('hide');
        modal.find('form')[0].reset();

    });

    $('#edit_slide_images').on("submit", function(e) {
        e.preventDefault();

        let form = $(this);
        let url = form.find('[name="url"]').val();
        let link_type = form.find('[name="link_type"]').val();

        if (link_type != 'external_link') {
            let url_post = window._routes['microsites.contents.block.check_link_slug'].replace('{microsite}', window.microsite_id).replace('{content}', window.content_id);
    
            let form_data = new FormData();
            form_data.append('link_type', link_type);
            form_data.append('slug', url);
    
            window.forms.post(url_post, form_data, true, true)
                .then((response) => {
                    if (response.data == true) {
                        save_slide_atributes(form);
                    } else {
                        window.messages.error(__('No existe el slug indicado'));
                    }
                })
                .catch((error) => {
                    console.log('ERROR', error);
                })
                .finally(() => {
                    window.blockui.release();
                });
        } else {
            save_slide_atributes(form);
        }
    });

    $('#add_slide_images').on("submit", function(e) {
        e.preventDefault();

        let form_data = new FormData($(this)[0]);

        let newImages = form_data.getAll('media[]');

        let media_ids = [];
        newImages.forEach(function(element, key) {
            media_ids.push(window.app.microsites.contents.get_random_id(10));
        });

        form_data.append('new_block_id', window.app.microsites.contents.get_random_id(10));
        form_data.append('media_ids', JSON.stringify(media_ids));
        form_data.append('type', 'slide_images');
        form_data.append('blank', $(this).find('[name="blank"]').prop('checked'));
        form_data.append('nofollow', $(this).find('[name="nofollow"]').prop('checked'));

        let translations = {};
        for(let _language of window._content_languages){
            translations[_language] = {'alt': '', 'url': ''};
            translations[_language]['alt'] = form_data.get('alt');
            translations[_language]['url'] = form_data.get('url') ?? '';
        }

        form_data.append('translations', JSON.stringify(translations));

        let modal = $(this).closest('.modal');
        modal.modal('hide');
        $(this)[0].reset();

        get_slide_view(form_data);
        
    });

    $('#content_blocks .slides_images').closest('.block').each(function(){
        init_slides($(this).attr('id'));
    });

    $('.block[data-type="slider_images"]').each(function(){
        init_slider_images_block($(this).attr('id'));
        content_blocks.create_visible_button_blocks($(this));
    });
}

function save_slide_atributes(form) {

    let slide = $('#'+ form.find('[name="slide_images_id"]').val());

    let alt = form.find('[name="alt"]').val();
    let url = form.find('[name="url"]').val();
    let link_type = form.find('[name="link_type"]').val();

    if (link_type == 'external_link' && url != '') {
        //url ha de empezar por http:// o https://
        const patronURL = /^(https?:\/\/)/;
        if (!patronURL.test(url)) {
            url = 'https://'+url;
        }
    }

    let translations = [];
    if(window._content_languages.length > 1){

        try {
            translations = JSON.parse(slide.attr('data-translations'));
            if (typeof translations == 'string' || (Array.isArray(translations) && translations.length == 0)) {
                translations = {};
            }

        } catch(err){
            translations = {};
        }

        // preparo traducciones que no existan

        for(let _language of window._content_languages){
            if(typeof translations[_language] == 'undefined'){
                translations[_language] = { 'alt': alt, 'url': url, 'img_name': slide.attr('data-img-name'), 'img_url': slide.attr('data-img-url'), 'media_id': slide.attr('data-media-id')};
            }
        }

        // guardo tranduccion actual 

        translations[window._content_selected_language]['alt'] = alt;
        translations[window._content_selected_language]['url'] = url;

        // si es idioma base

        if(window._content_selected_language == window._locale){

            slide.attr('data-alt', alt);
            slide.attr('data-url', url);

            // actualizamos traducciones vacias

            for(let _language of window._content_languages){
                if(_language != window._locale){
                    if(translations[_language]['alt'] == ''){
                        translations[_language]['alt'] = alt;
                    }

                    if(translations[_language]['url'] == ''){
                        translations[_language]['url'] = url;
                    }
                }
            }
        }

        if (link_type != 'external_link' || slide.attr('data-link-type') != link_type) {
            for(let _language of window._content_languages){
                translations[_language]['url'] = url;
            }
        }

    } else {

        slide.attr('data-alt', alt);
        slide.attr('data-url', url);
    }


    slide.attr('data-class', form.find('[name="classes"]').val());
    slide.attr('data-visible', form.find('[name="visible"]').val());
    slide.attr('data-link-type', link_type);
    slide.attr('data-blank', form.find('[name="blank"]').prop('checked'));
    slide.attr('data-nofollow', form.find('[name="nofollow"]').prop('checked'));
    slide.attr('data-translations', JSON.stringify(translations));

    let form_data = new FormData(form[0]);
    form_data.append('new_block_id', form.find('[name="slide_images_id"]').val());
    form_data.append('type', 'slide_images');

    if (form_data.get('media') != null && form_data.get('media').name != '') {
        update_slide_image(form_data, slide);
    }

    content_blocks.change_visible_button_blocks(slide);

    let modal = form.closest('.modal');
    modal.modal('hide');
    
    form[0].reset();
}

export function get_slide_view(form_data) {

    let url = window._routes['microsites.contents.block'].replace('{microsite}', window.microsite_id).replace('{content}', window.content_id);

    window.forms.post(url, form_data, true, true)
            .then((response) => {
                if (response.data.message) {
                    switch (response.data.message_level) {
                        case 'error':
                            window.messages.error(response.data.message);
                            break;
    
                        case 'warning':
                            window.messages.warning(response.data.message);
                            break;
                    
                        default:
                            window.messages.info(response.data.message);
                            break;
                    }
                    
                } else {
                    if (response.data.prev_slide_images_id != null) {
                        $('#' + response.data.prev_slide_images_id).after(response.data.slide_images);
                    } else {
                        $('#' + response.data.row_id + ' .slides_images').append(response.data.slide_images);
                    }

                    // if (response.data.media_ids != null && response.data.media_ids != '') {
                    //     let media_ids = JSON.parse(response.data.media_ids);
                    //     media_ids.forEach(element => {
                    //         let slide = $('#'+ element);
                    //         slide.attr('data-class', form_data.get("classes"));
                    //         slide.attr('data-visible', form_data.get("visible"));
                    //         content_blocks.change_visible_button_blocks($('#' + element));
                    //     });
                    // } else {
                    //     let slide = $('#'+ response.data.slide_images_id);
                    //     slide.attr('data-class', form_data.get("classes"));
                    //     slide.attr('data-visible', form_data.get("visible"));
                    //     content_blocks.change_visible_button_blocks($('#' + response.data.slide_images_id));
                    // }

                    init_slides(response.data.row_id);
                    init_slider_images_block(response.data.row_id);
                    
                }
            })
            .catch((error) => {
                console.log('ERROR', error);
            })
            .finally(() => {
                window.blockui.release();
            });
}

export function show_block_order(row_id){

    let slides = $('#' + row_id +' .slides_images .slide_images');

    if (slides.length > 1) {

        for(let i=0; i<slides.length; i++){

            $(slides[i]).find('.slide_up').show().prop('disabled', i == 0);
            $(slides[i]).find('.slide_down').show().prop('disabled', i == slides.length - 1);
            $(slides[i]).find('.move_slide').show();
    
            content_blocks.show_block_order($(slides[i]).attr('id'));
        }

    } else {

        for(let i=0; i<slides.length; i++){

            $(slides[i]).find('.slide_up').hide().prop('disabled', i == 0);
            $(slides[i]).find('.slide_down').hide().prop('disabled', i == slides.length - 1);
            $(slides[i]).find('.move_slide').hide();
    
            content_blocks.show_block_order($(slides[i]).attr('id'));
        }
    }
}

export function init_slides(row_id){

    $('#content_blocks #' + row_id + ' .slides_images .slide_images:not(.init)').each(function(){
        let slide_images_id = $(this).attr('id');

        $('#' + slide_images_id).find('.btn.slide_up').click(function(){
                
            let row_id = $(this).closest('.block[data-type="slider_images"]').attr('id');
            
            let slide = $(this).closest('.slide_images');
            let prev_slide = slide.prev();
            slide.detach();
            prev_slide.before(slide);

            show_block_order(row_id);

        });

        $('#' + slide_images_id).find('.btn.slide_down').click(function(){
            let row_id = $(this).closest('.block[data-type="slider_images"]').attr('id');
            let slide = $(this).closest('.slide_images');
            let next_slide = slide.next();
            slide.detach();
            next_slide.after(slide);
            
            show_block_order(row_id);
        });

        $('#' + slide_images_id).find('.btn.slide_edit').click(function(){
            
            let form = $('#edit_slide_images');
            let slide = $(this).closest('.slide_images');
            let block = $(this).closest('.block');
            let alt = slide.attr('data-alt');
            let url = slide.attr('data-url');

            try {

                let translations = JSON.parse(slide.attr('data-translations'));
                if(typeof translations[window._content_selected_language] != 'undefined'){

                    if(typeof translations[window._content_selected_language]['alt'] != 'undefined'){
                        alt = translations[window._content_selected_language]['alt'];
                    }

                    if(typeof translations[window._content_selected_language]['url'] != 'undefined'){
                        url = translations[window._content_selected_language]['url'];
                    }
                }
            } catch(err){
                console.log(err);
            }

            form.find('[name="block_id"]').val(block.attr('id'));
            form.find('[name="slide_images_id"]').val(slide.attr('id'));
            form.find('[name="classes"]').val(slide.attr('data-class'));
            form.find('[name="alt"]').val(alt);
            form.find('[name="url"]').val(url);
            form.find('[name="blank"]').prop('checked', slide.attr('data-blank') == 'true' ? true : false);
            form.find('[name="nofollow"]').prop('checked', slide.attr('data-nofollow') == 'true' ? true : false);

            let select_link_type = form.find('[name="link_type"]');
            if (slide.attr('data-link-type') != null || slide.attr('data-link-type') != 'undefined') {
                select_link_type.find('option[value="'+ slide.attr('data-link-type')).prop('selected', true);
            } else {
                select_link_type.find('option[value="external_link"]').prop('selected', true);
            }
            
            select_link_type.select2({
                minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
                theme: 'bootstrap',
                width: 'resolve',
            });

            let select_visible = form.find('[name="visible"]');
            
            if (slide.attr('data-visible') != null || slide.attr('data-visible') != 'undefined') {
                select_visible.find('option[value="'+ slide.attr('data-visible')).prop('selected', true);
            } else {
                select_visible.find('option[value="visible"]').prop('selected', true);
            }
            
            select_visible.select2({
                minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
                theme: 'bootstrap',
                width: 'resolve',
            });


            let image = form.find('input[name="media"]');
            let label = image.next('label');
            label.text(slide.attr('data-img-name'));
        });


        content_blocks.change_visible_button_blocks($(this));
        // // inicializar bloque
        $(this).addClass('init');
        
    });
    
    show_block_order(row_id);

}

export function init_slider_images_block(block_id) {

    let block = $('#content_blocks #' + block_id);
    let card_body = block.find('.card-body');
    let card_empty_body = block.find('.card-empty-body');
    if (card_body.find('.slide_images').length <= 0) {
        card_empty_body.removeClass('d-none');
        card_empty_body.addClass(['d-flex', 'justify-content-center']);
    } else {
        card_empty_body.addClass('d-none');
        card_empty_body.removeClass('d-flex');
    }

    $('#content_blocks #' + block_id + ' .slides_images .move_slide').each(function(){

        $(this)[0].addEventListener("dragstart", (event) => {
            event.stopPropagation();

            let block = $(event.target).closest('.drag-container');
            block.addClass('dragging');

            let slide = $(event.target).closest('.slide_images');

            event.dataTransfer.effectAllowed = 'move';
            event.dataTransfer.setData('text/plain', slide.attr('id'));

            var dragImage = document.createElement('div');
            dragImage.id = 'drag-handler';
            dragImage.innerHTML = '<i class="fa-solid fa-plane"></i>';
            dragImage.setAttribute('style', 'position: absolute; left: 0px; top: 0px; width: 30px; height: 30px; z-index: -1');
            document.body.appendChild(dragImage);
            event.dataTransfer.setDragImage(dragImage, 20, 20);

        });
    
        $(this)[0].addEventListener("dragend", (event) => {
        
            $('#drag-handler').remove();
            
            let block = $(event.target).closest('.drag-container');
            block.removeClass('dragging');
    
        });

    });

    $('#content_blocks #' + block_id + ' .slides_images > .slide_images > .btn-drop').each(function(){
        
        $(this)[0].addEventListener("dragover", (event) => {
            event.preventDefault();
        });

        $(this)[0].addEventListener("dragenter", (event) => {
            event.preventDefault();
            if(event.dataTransfer.getData('text/plain') != $(event.target).closest('.slide_images').attr('id')){
                $(event.target).addClass('drop');
            }
        });

        $(this)[0].addEventListener("dragleave", (event) => {
            event.preventDefault();
            $(event.target).removeClass('drop');
        });
    
        $(this)[0].addEventListener("drop", (event) => {
            event.stopPropagation();

            let slide = $('#' + event.dataTransfer.getData('text/plain'));
            let move_after = $(event.target).closest('.slide_images');

            if(
                slide.length > 0 
                && move_after.length > 0
                && slide.attr('id') != move_after.attr('id')
            ){
                move_after.after(slide.detach());
            }
            
        });

    });

}

function update_slide_image(form_data, slide) {
    let url = window._routes['microsites.contents.media'].replace('{microsite}', window.microsite_id).replace('{content}', window.content_id);

    form_data.append('type', slide.attr('data-type'));
    window.forms.post(url, form_data, true, true)
        .then((response) => {

            if (response.data != null) {
                slide.attr('data-img-url', response.data.src);
                slide.attr('data-img-name', response.data.name);
                slide.attr('data-media-id', response.data.media_id);

                if(window._content_languages.length > 1){
                    let translations = JSON.parse(slide.attr('data-translations'));

                    translations[window._content_selected_language]['img_url'] = response.data.src;
                    translations[window._content_selected_language]['media_id'] = response.data.media_id;
                    translations[window._content_selected_language]['img_name'] = response.data.name;

                    slide.attr('data-translations', JSON.stringify(translations));
                }
                let card_body = slide.find('.card-body');
                card_body.find('img').attr('src', response.data.src);
            }
                            
        })
        .catch((error) => {
            console.log('ERROR', error);
        })
        .finally(() => {
            window.blockui.release();
        });
}

function create_preview(alt, img_url) {

    let div = '<div class="wrapper'+
        '">'+
            '<img'+ 
                ' style="width: 100%"'+
                ' src="'+ (img_url != '' ? img_url : '') +'"'+
                ' alt="'+ (alt ? alt : '')+'">'+
        '</div>';

    return div;
}
